module.exports = {"120111001":"西营门街道","120111002":"李七庄街道","120111003":"赤龙南街道","120111100":"中北镇","120111101":"杨柳青镇","120111102":"辛口镇","120111103":"张家窝镇","120111104":"精武镇","120111105":"大寺镇","120111106":"王稳庄镇","120111400":"天津开发区微电子小区","120111401":"新技术产业园区","120111402":"西青高校区","120111450":"西青区开发区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/120111.json
// module id = 47
// module chunks = 0